import {
  BYPASS_QUERY_PARAM,
  COUNTRY_COOKIE,
  EXCLUDED_PATHS,
  HOME_COUNTRY,
} from "./config";

export function getCookie(name) {
  if (typeof document === "undefined") return null;

  const match = document.cookie.match(
    new RegExp(`(?:^|; )${name.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")}=([^;]*)`)
  );

  return match ? decodeURIComponent(match[1]) : null;
}

export function normalizePathname(pathname) {
  if (!pathname) return "/";

  const withoutLocale = pathname.replace(/^\/en(?=\/|$)/, "") || "/";
  return withoutLocale.endsWith("/") && withoutLocale !== "/"
    ? withoutLocale.slice(0, -1)
    : withoutLocale;
}

export function isExcludedPath(pathname) {
  const normalized = normalizePathname(pathname);

  return EXCLUDED_PATHS.some((excluded) => {
    if (normalized === excluded) return true;
    return normalized.startsWith(`${excluded}/`);
  });
}

export function hasBypassQueryParam(search) {
  if (typeof window === "undefined") return false;

  const params = new URLSearchParams(search || window.location.search);
  return params.get(BYPASS_QUERY_PARAM) === "true";
}

export function stripBypassQueryParam() {
  if (typeof window === "undefined") return;

  const url = new URL(window.location.href);
  if (!url.searchParams.has(BYPASS_QUERY_PARAM)) return;

  url.searchParams.delete(BYPASS_QUERY_PARAM);
  window.history.replaceState({}, "", url.toString());
}

export function getDetectedCountry(search = "") {
  const query = search || (typeof window !== "undefined" ? window.location.search.slice(1) : "");
  const params = new URLSearchParams(query);
  const fromQuery = params.get("cf_country");

  if (fromQuery) return fromQuery.toUpperCase();

  return (getCookie(COUNTRY_COOKIE) || "").toUpperCase();
}

export function shouldShowGeoBanner({ pathname, search }) {
  if (hasBypassQueryParam(search)) return false;
  if (isExcludedPath(pathname)) return false;

  const country = getDetectedCountry(search);
  if (!country || country === HOME_COUNTRY) return false;

  return true;
}

export function getClientRouteContext() {
  if (typeof window === "undefined") {
    return { pathname: "/", search: "" };
  }

  return {
    pathname: window.location.pathname,
    search: window.location.search.slice(1),
  };
}
